import React from 'react'
import BaseIcon from 'react-icon-base'

const Facebook = props => (
  <BaseIcon width="20" height="20" viewBox="0 0 20 20" {...props}>
    <path
      fill="#3B5999"
      d="M20 10c0-5.522-4.478-10-10-10S0 4.478 0 10s4.478 10 10 10l.176-.002v-7.785H8.027V9.71h2.149V7.867c0-2.137 1.304-3.3 3.21-3.3.913 0 1.698.068 1.927.098V6.9h-1.315c-1.037 0-1.238.493-1.238 1.216v1.594h2.48l-.323 2.504H12.76v7.4C16.94 18.416 20 14.566 20 10z"
    />
  </BaseIcon>
)

export default Facebook
